import ProgressionWrapper from './progressionWrapper'
export default ProgressionWrapper
